<template>
    <div class="h-100 w-100 d-flex justify-content-center align-items-center systemSelect flex-column">
        <div>
            <img src="/img/brand/logo.png" style="height: 100px;">
        </div>
        <h3 class=" ">
            XIN VUI LÒNG CHỌN PHÂN HỆ
        </h3>
        <div class="d-flex justify-content-around align-items-center systemCards">
            <div v-for="item in systems" @click="handlePick(item.systemId)"
                class="systemCard bg-hover-primary  p-2 d-flex flex-column justify-content-between align-items-center rounded-lg border-0  m-4 shadow">
                <div class="h-100 d-flex align-items-center justify-content-center">
                    <i :class="item.systemIcon + '  '" aria-hidden="true"></i>
                </div>
                <h5 class=" ">
                    {{ item.name }}
                </h5>
            </div>
        </div>
    </div>
</template>
<script>
import { CookieComponent } from "@/assets/ts/components";
export default {
    name: 'select-system',
    data() {
        return {
            systems: [
                { name: "BÁN HÀNG TRỰC TRUYÊN", systemId: 1, systemIcon: "fa fa-shopping-bag" },
                { name: "MINI APP", systemId: 2, systemIcon: "fa fa-window-restore" }
            ]
        }
    },
    methods: {
        async handlePick(val) {
            await CookieComponent.set("system", val)
            this.$nextTick(() => {
                this.$router.push('/sign-in')
            })

        }
    },
    mounted(){
        CookieComponent.delete("system")
    }
};
</script>
<style lang="scss" scoped></style>
